import script from "./QuestionCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionCard.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionCard.vue?vue&type=style&index=0&id=7025be87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7025be87"]])

export default __exports__